import { ArrowUpTrayIcon } from "@heroicons/react/24/outline";
import type { ButtonProps } from "../Button";
import { Button } from "../Button";

export interface FileUploadButtonProps extends ButtonProps {
  className?: string;
  allowedExtensions?: string[];
  filesChanged: (files: FileList | null) => void;
}

/**
 *
 */
export function FileUploadButton({
  className,
  filesChanged,
  allowedExtensions,
  disabled,
  vSize,
  vColor,
  children,
  "data-testid": dataTestId,
  ...props
}: FileUploadButtonProps) {
  const testId = dataTestId || "file-upload-button";

  return (
    <Button
      className={className}
      disabled={disabled}
      vColor={vColor}
      vSize={vSize}
      data-testid={testId}
      {...props}
    >
      <input
        accept={
          allowedExtensions?.length ? allowedExtensions.join(", ") : undefined
        }
        className="absolute inset-0 cursor-pointer opacity-0"
        disabled={disabled}
        data-testid="file-upload-input"
        onChange={(e) => filesChanged(e.target.files)}
        type="file"
      />
      {children || (
        <>
          Upload File <ArrowUpTrayIcon className="h-5 pl-2 font-bold" />
        </>
      )}
    </Button>
  );
}
